import actions from './actions';

const initialState = {
  allProduct: [],
  selectedProduct: '',
};

const {
  GET_ALL_PRODUCT_SUCCESS,
  GET_ALL_PRODUCT_ERR,
  SET_ALL_PRODUCT_SUCCESS,
  SET_ALL_PRODUCT_ERR,
  GET_SELECTED_PRODUCT_SUCCESS,
  GET_SELECTED_PRODUCT_ERR,
  SET_SELECTED_PRODUCT_SUCCESS,
  SET_SELECTED_PRODUCT_ERR,
} = actions;

const allProductDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ALL_PRODUCT_SUCCESS:
      return state;
    case GET_ALL_PRODUCT_ERR:
      return err;
    case SET_ALL_PRODUCT_SUCCESS:
      return {
        ...state,
        allProduct: data,
      };
    case SET_ALL_PRODUCT_ERR:
      return err;
    case GET_SELECTED_PRODUCT_SUCCESS:
      return state;
    case GET_SELECTED_PRODUCT_ERR:
      return err;
    case SET_SELECTED_PRODUCT_SUCCESS:
      return {
        ...state,
        selectedProduct: data,
      };
    case SET_SELECTED_PRODUCT_ERR:
      return err;
    default:
      return state;
  }
};

export { allProductDataReducer };

